import { useSelector } from "react-redux";
import Header from "./Header";
import Sidebar from "./Sidebar";
import useCohortBootstrap from "../hooks/useCohortBootstrap";

export default function MainLayout({ children }) {
  const role = useSelector(state => state.auth.role);

  // 🔥 FETCH COHORTS FOR BOTH ROLES
  useCohortBootstrap();

  return (
    <>
      <Header />
      <div className="app-layout">
        {/* {role === "business" && <Sidebar />} */}
        { <Sidebar />}

        <div className="content">
          {children}
        </div>
      </div>
    </>
  );
}
